import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material';
import { MainService } from '../main.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  passwordForm: FormGroup;
  formSubmitted: boolean = false;
  isLoading:boolean = false;

  constructor(
    private fb: FormBuilder,
    private SettingService: MainService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.initialiseForms();
   //s this.gotoTop();
   
  }

  initialiseForms() {
    this.passwordForm = this.fb.group({
      oldPassword: ["", [Validators.required, Validators.minLength(6)]],
      newPassword: ["", [Validators.required, Validators.minLength(6)]],
    });
  }

  gotoTop() {
    const mainDiv = document.getElementById('mainDIV');
     mainDiv.scrollTop = 0;		
     window.scrollTo(0, 0);

    }

  changePassword() {
    this.formSubmitted = true;
    if (this.passwordForm.valid) {
      let reqobj = {
        oldPassword: this.passwordForm.value.oldPassword,
        newPassword: this.passwordForm.value.newPassword
      }

      this.isLoading = true;
      this.SettingService.changePassword(reqobj).subscribe(data => {
        this.isLoading = false;
        if (data["message"] == "Success") {
          this.passwordForm.reset();
          this.formSubmitted = false;
          this.isLoading = false;
          this._snackBar.open("Password changed successfully","",{
            duration: 3000,
            horizontalPosition:'right',
            verticalPosition:'top',
            panelClass: ['failure']
          });
        } 
      }, err => {
        this.isLoading = false;
      });
    }
  }
}

